// Debug flags
export const DEBUG = {
  SURVEY: false,
  NAVIGATION: false,
  STATE: false,
  SURVEY_CREATOR: false,
  SURVEY_INSIGHTS: false,
  SURVEY_SUBMISSION: false,
  ROLE_SELECTION: false,
  AI_PROCESSOR: false,
  AI_PROVIDER: false,
  ADMIN_ACCESS: false,
  SIGNUP: false,
  ANALYTICS: true // Add analytics debug flag, true by default for easier testing
} as const;

export const SITE_CONFIG = {
  DISABLE_SIGNUP: false,
  SKIP_EMAIL_CONFIRMATION: true, // Add this new constant
  DATABASE_OFFLINE_DETECTION: true, // Enable automatic detection of database availability
  FORCE_DATABASE_OFFLINE: false // Manual override to force database offline mode
} as const;

export const COOKIE_TYPES = {
  analytics: {
    name: 'Analytics',
    description: 'Help us understand how visitors interact with our website.',
  },
  advertising: {
    name: 'Advertising',
    description: 'Used to deliver personalized advertisements.',
  },
} as const;

// Survey configuration constants
export const SURVEY_CONFIG = {
  MAX_RESPONSES: 20, // Maximum number of responses per survey
  DEFAULT_EXPIRY_DAYS: 7, // Default survey expiry in days
  PROCESSING: {
    COOLDOWN_HOURS: 24,
    MAX_TOTAL_ATTEMPTS: 3
  },
  MAX_SURVEYS_PER_MANAGER: 3
} as const;

// Navigation item type
type NavigationItem = {
  name: string;
  href: string;
  separator?: boolean; // Show horizontal line above this item
  highlighted?: boolean; // Make this item bold/emphasized
  children?: NavigationItem[];
};

// Navigation items
export const NAVIGATION_ITEMS: NavigationItem[] = [
  { name: 'Home', href: '/' },
  {
    name: 'Services',
    href: '/services',
    children: [
      { name: 'Our Services', href: '/services' },
      { name: 'Knowledge Engineering', href: '/services/knowledge-engineering' },
      { name: 'Partner AI', href: '/services/partner-ai' },
      { name: 'Operational Assessment', href: '/services/operational-assessment' },
      { name: 'AI Opportunities', href: '/services/ai-opportunity' },
      { name: 'AI Kickstarter', href: '/services/ai-kickstarter', separator: true },
      { name: 'Strategic Transformation', href: '/services/strategic-transformation' }
    ]
  },
  {
    name: 'About Us',
    href: '/our-approach',
    children: [
      { name: 'Our Approach', href: '/our-approach' },
      { name: 'Meet the Team', href: '/meet-the-team' }
    ]
  },
  { name: 'Success Stories', href: '/success-stories' },
  { name: 'Insights', href: '/insights' }
];

// Framework categories
export const FRAMEWORKS = [
  {
    category: 'Strategic Foundations',
    items: [
      'Vision & Strategy',
      'Setting Goals',
      'Roadmapping',
    ],
  },
  {
    category: 'Operational Excellence',
    items: [
      'Align & Collaborate',
      'Balancing Priorities',
      'Prototyping Enablement',
    ],
  },
  {
    category: 'Momentum & Impact',
    items: [
      'Amplify & Launch',
      'Igniting Passion',
      'Sustaining Momentum',
    ],
  },
] as const;